import { FC } from "react"; // Importing FC type from React for functional components

import "./label.scss"; // Importing SCSS styles for the Label component

interface IContent {
  content?: string | JSX.Element; // The content to be displayed in the label, can be a string or JSX element
  className?: string; // Optional additional CSS class for styling
}

/**
 * Label component displays a piece of content with optional styling.
 *
 * @param {IContent} props - The properties object for the Label component.
 * @param {string | JSX.Element} [props.content] - The content to be displayed in the label.
 * @param {string} [props.className] - Optional additional CSS class for styling.
 *
 * @returns {JSX.Element} The rendered Label component.
 */
export const Label: FC<IContent> = ({ content, className = "" }) => {
  if (!content) {
    return <></>; // Return an empty fragment if no content is provided
  }
  return (
    <div className={`simplci-auth-label ${className}`}>
      {content} {/* Render the content inside a div with the specified class */}
    </div>
  );
};
